import CourseDetailsHeader from "./CourseDetailsHeader";
import BundleCourses from "./BundleCourses";
import CourseBundleDescription from "./CourseBundleDescription";

function CourseInnerBundle({className}) {

  return (
    <div className={`${className || ""} course-inner-bundle p-0`}>
      <CourseDetailsHeader />
      <BundleCourses />
      <CourseBundleDescription courseBundleDescTitle="Description for bundle" courseBundleDesc="The HIPAA Basics course will introduce you to the Health Insurance Portability and Accountability Act of 1996 or HIPAA in a simple yet informative way. This course also focuses on helping the learner gain an understanding of the following topics:"/>
    </div>
  );
}

export default CourseInnerBundle;
